import type { Feature } from "~/types/api";
import { BaseAPI } from "./base";
import type { ApiResponse } from "~/types/ui";

export class FeatureApi extends BaseAPI {
  async getFeatures(companyId?: number): Promise<ApiResponse<Feature[]>> {
    return this.get<Feature[]>(
      `features/${companyId !== undefined ? companyId : this.company()}`,
    );
  }
}
